<template>
    <div
        v-show="text !== ''"
        :style="[dynamicStyle]"
        class="editable-zone"
        :class="zone.style"
    >{{ text }}</div>
</template>

<script>

export default {

    components: {

    },

    props: {
        zone: {
            type: Object,
            required: true,
        },
        canvasWidth: {
            type: Number,
            required: true,
        },
        pageIndex: {
            type: Number,
            required: true,
        },
        fieldName: {
            type: String,
            required: true,
        },
        roundHighValues: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    data (){
        return {
            mmPdfWidth: 297,
            maxCanvasWidth: 843,
            text: '',
            fontSizePerClass: {
                'white-bold-text': 16 ,
                'white-text': 16,
                'expert-notice-text': 9,
                'big-orange-bold-text': 16,
                'orange-bold-text': 9,
                'orange-text': 9,
                'blue-bold-text': 9,
                'blue-text': 9,
                'title': 32,
                'title': 18,
                'text': 9,
                'light-orange-bubble-white-text': 32 ,
                'white-bubble-light-orange-text': 7 ,
                'orange-bubble-white-text': 32 ,
                'white-bubble-orange-text': 7 ,
            }
        };
    },

    computed: {
        dynamicStyle (){
            return {
                top: this.calculY+'px',
                left: this.calculX+'px',
                width: this.calculW+'px',
                height: this.calculH+'px',
                fontSize: this.calculFontSize+'px',
            }
        },

        calculX (){
            let x = this.zone.x * this.maxCanvasWidth / this.mmPdfWidth;
            if(this.canvasWidth === this.maxCanvasWidth || this.canvasWidth === 0) return x;
            return (this.canvasWidth * x / this.maxCanvasWidth);
        },
        calculY (){
            let y = this.zone.y * this.maxCanvasWidth / this.mmPdfWidth;
            if(this.canvasWidth === this.maxCanvasWidth || this.canvasWidth === 0) return y;
            return (this.canvasWidth * y / this.maxCanvasWidth);
        },
        calculW (){
            let w = this.zone.w * this.maxCanvasWidth / this.mmPdfWidth;
            if(this.canvasWidth === this.maxCanvasWidth || this.canvasWidth === 0) return w;
            return this.canvasWidth * w / this.maxCanvasWidth;
        },
        calculH (){
            let h = this.zone.h * this.maxCanvasWidth / this.mmPdfWidth;
            if(this.canvasWidth === this.maxCanvasWidth || this.canvasWidth === 0) return h;
            return this.canvasWidth * h / this.maxCanvasWidth;
        },
        calculFontSize (){
            let fontSize = this.fontSizePerClass[this.zone.style[0]];
            if(this.canvasWidth === this.maxCanvasWidth || this.canvasWidth === 0) return fontSize;
            return this.canvasWidth * fontSize / this.maxCanvasWidth;
        },

    },
    mounted (){
        this.$eventBus.$on('change-pdf-value', (data) => {
            if(data.pageIndex === this.pageIndex && data.fieldName === this.fieldName){
                if (this.roundHighValues === true && !Number.isNaN(parseFloat(data.newValue))) {
                    // limit value to 2 decimal
                    let dataValue = Math.round(parseFloat(data.newValue) * 100) / 100;
                    if (dataValue >= 10000) {
                        this.text = `${Math.round(dataValue / 100) / 10}K`;
                    } else if (parseFloat(data.newValue) >= 1000) {
                        this.text = Math.round(dataValue);
                    } else {
                        this.text = dataValue;
                    }
                } else {
                    this.text = data.newValue;
                }
            }
        });
    },
    beforeDestroy(){
        this.$eventBus.$off('change-pdf-value');
    },

    methods: {
    },
};
</script>

<style lang="scss">
    .editable-zone{
        color: #000;
        position: absolute;
        white-space: pre-line;
        line-height: 1;
        overflow: hidden;
    }
    .title{
        font-family: 'work sans', cursive;
        color: #fd5714;
    }
    .sub-title{
        font-family: 'work sans', cursive;
        color: #001a6f;
    }
    .text{
        font-family: 'frutiger';
        color: #001a6f;
    }
    .white-bold-text{
        font-family: "work sans bold", cursive;
        font-size: 16px;
        color: #fff;
    }
    .white-text{
        font-family: "work sans", cursive;
        font-size: 16px;
        color: #fff;
    }
    .expert-notice{
        background-image: url('../../../../static/img/citation.svg');
        background-repeat: no-repeat;
        padding: 39px 0 0 26px;
        background-position-y: 0px;
        background-size: 100px auto;
    }
    .expert-avatar-1{
        background-image: url('../../../../static/img/expert01.svg');
        background-repeat: no-repeat;
        padding-top: 90px;
        background-position-y: 0px;
        background-size: 80px auto;
    }
    .expert-avatar-2{
        background-image: url('../../../../static/img/expert02.svg');
        background-repeat: no-repeat;
        padding-top: 90px;
        background-position-y: 0px;
        background-size: 80px auto;
    }
    .expert-notice-text{
        font-family: "frutiger";
        font-size: 9px;
        color: #001a6f;
    }
    .big-orange-bold-text{
        font-family: "work sans bold", cursive;
        font-size: 16px;
        color: #fd5714;
    }
    .orange-bold-text{
        font-family: "work sans bold", cursive;
        font-size: 9px;
        color: #fd5714;
    }
    .orange-text{
        font-family: "work sans", cursive;
        font-size: 9px;
        color: #fd5714;
    }
    .blue-bold-text{
        font-family: "work sans bold", cursive;
        font-size: 9px;
        color: #001a6f;
    }
    .blue-text{
        font-family: "work sans", cursive;
        font-size: 9px;
        color: #001a6f;

    }
    .light-orange-bubble-white-text {
        font-family: "work sans extra light", cursive;
        text-align: center;
        color: #fff;
    }
    .orange-bubble-white-text {
        font-family: "work sans extra light", cursive;
        text-align: center;
        color: #fff;
    }
    .white-bubble-light-orange-text {
        font-family: "work sans", cursive;
        text-align: center;
        color: #fd5714;
    }
    .white-bubble-orange-text {
        font-family: "work sans bold", cursive;
        text-align: center;
        color: #f85816;
    }
</style>



// WEBPACK FOOTER //
// src/components/page/report/editableZone.vue